import React from 'react';

const YES_NO_OPTIONS = [
  { label: 'No', value: 'No' },
  { label: 'Yes', value: 'Yes' },
];

interface YesNoRadioGroupProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  showMoreDetails?: boolean;
  detailsValue?: string;
  onDetailsChange?: (value: string) => void;
  error?: string;
  detailsError?: string;
}

const YesNoRadioGroup: React.FC<YesNoRadioGroupProps> = ({
  label,
  name,
  value,
  onChange,
  required,
  showMoreDetails,
  detailsValue,
  onDetailsChange,
  error,
  detailsError,
}) => (
  <div className={error || detailsError ? 'error' : ''}>
    <div className='gray-card'>
      <label>
        {label}
        {required && <span className='required'>*</span>}
      </label>
      <div className='radio-group-options'>
        {YES_NO_OPTIONS.map((option) => {
          const optionId = `${name}-${option.value}`;
          return (
            <div key={optionId} className='radio-group-option'>
              <input
                type='radio'
                id={optionId}
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={() => onChange(option.value)}
              />
              <label htmlFor={optionId}>{option.label}</label>
            </div>
          );
        })}
      </div>
      {showMoreDetails && value === 'Yes' && (
        <>
          <input
            type='text'
            className='more-details-input'
            value={detailsValue || ''}
            onChange={(e) => onDetailsChange?.(e.target.value)}
            placeholder='Please provide details'
          />
          {detailsError && <div className='error-text-message'>{detailsError}</div>}
        </>
      )}
    </div>
    {error && <div className='error-text-message'>{error}</div>}
  </div>
);

export default YesNoRadioGroup;
